import React from 'react';
import { Redirect } from 'react-router-dom';
import { withIonLifeCycle } from '@ionic/react';
import LoadingIndicator from 'src/components/LoadingIndicator';
import app from 'src/feathers';
import alerts from 'src/lib/alerts';

class WithRecordComponent extends React.Component {
  constructor(props) {
    super(props);
    const { service } = this.props;
    this.service = app.service(service);
    this.store = app.get('stateContainer').state[this.service.name];
    // Initially return what we know from store, will return undefined
    // if there is no store or item is not in store
    const record =
      this.store && this.store.find((record) => record._id === this.props._id);
    this.state = {
      hasLeft: false,
      fetching: false,
      fetched: false,
      delaying: true,
      record
    };
  }

  ionViewWillEnter = () => {
    if (this.props.useLifecycle && this.state.hasLeft) {
      this.refresh();
    }
  };

  ionViewWillLeave = () => {
    if (this.props.useLifecycle) {
      this.setState({ hasLeft: true });
    }
  };

  componentDidMount() {
    this.refresh();
    this.timeout = setTimeout(() => {
      if (this.state.delaying) {
        this.setState({ delaying: false });
      }
    }, this.props.delay);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  refresh = async () => {
    this.setState({ fetching: true }, (newState) => {
      return this.service
        .get(this.props._id)
        .then((record) => {
          this.setState({
            fetching: false,
            fetched: true,
            delaying: false,
            record
          });
          return record;
        })
        .catch((error) => {
          // This is likely unfound. I could do some better error
          // checking here, but regardless it needs to go somewhere
          // that is not here.
          const { redirect, message } = this.props;
          this.setState({ redirect });
          if (message) {
            alerts.errors(message);
          }
        });
    });
  };

  render() {
    const { record, delaying, redirect } = this.state;
    if (redirect) {
      return <Redirect to={redirect} />;
    }
    if (record) {
      return this.props.render({
        ...this.state,
        refresh: this.refresh
      });
    } else if (!delaying) {
      return this.props.loader;
    } else {
      return null;
    }
  }
}

WithRecordComponent.defaultProps = {
  delay: 500,
  redirect: '/not-found',
  loader: (
    <div className="d-flex h-100vh align-items-center">
      <LoadingIndicator />
    </div>
  )
};

export default withIonLifeCycle(WithRecordComponent);
